import { createSlotRecipe } from './runtime.js';

const radioIndicatorConfig = {"name":"radioIndicator","slots":["indicatorArea","icon"],"defaultVariants":{"size":"md"},"variantMap":{"size":["md","sm"]}}

export const radioIndicator = /* @__PURE__ */ createSlotRecipe(radioIndicatorConfig)